import { FC, PropsWithChildren, useState } from 'react';
import { flushSync } from 'react-dom';
import { UserAppContext } from './UserAppContext';
import { UserApp } from './types';

const USER_APP_KEY = 'userApp';

export const UserAppProvider: FC<PropsWithChildren> = ({ children }) => {
  const [app, setApp] = useState<UserApp | null>(
    (localStorage.getItem(USER_APP_KEY) as UserApp | null) ?? null
  );

  const value = {
    app,
    storeApp: (newApp: UserApp) => {
      localStorage.setItem(USER_APP_KEY, newApp);
      flushSync(() => setApp(newApp));
    },
    resetApp: () => {
      localStorage.removeItem(USER_APP_KEY);
      flushSync(() => setApp(null));
    },
  };

  return <UserAppContext.Provider value={value}>{children}</UserAppContext.Provider>;
};
